import clientFetcher from '@finance/clientFetcher';
import { Temporal } from '@js-temporal/polyfill';
import { Document } from 'fluent-graphql';
import type { Errors, WalletTransfer } from '../types';

export interface CreateWalletTransferReturn {
  createWalletTransfer: WalletTransfer | Errors;
}

interface CreateWalletTransferVars {
  organizationId: string;
  input: unknown;
}

export default Document
  .mutation<CreateWalletTransferReturn, CreateWalletTransferVars>('CreateWalletTransfer')
    .variableDefinitions({ organizationId: 'ID!', input: 'CreateWalletTransferInput!' })
    .union('createWalletTransfer')
      .useVariables({ organizationId: 'organizationId', input: 'input' })
      .onEntity('WalletTransfer')
        .scalar('organizationId')
        .scalar('date', Temporal.PlainDate.from)
        .reference('sourceCurrencyId', 'Currency')
        .reference('targetCurrencyId', 'Currency')
        .reference('sourceWalletId', 'Wallet')
        .reference('targetWalletId', 'Wallet')
        .scalar('sourceAmount')
        .scalar('targetAmount')
        .scalar('description')._
      .onTypedObject('NegativeWalletBalance')
        .scalar('name')
        .scalar('currencyName')
        .scalar('balanceAmount')._
      .onTypedObject('InputErrors')
        .scalar('errors')._._._
  .makeExecutable(clientFetcher)
  .afterExecution(({ createWalletTransfer: data }) => {
    if (data.__typename === 'WalletTransfer') {
      Document.clearQueries([
        'WalletTransfers',
        'WalletTransactions',
        'Wallets'
      ]);
    }
  });
